import React from "react";
import Story from "./Story";
import "./StoryReel.css";

function StoryReel() {
  return (
    <div className="storyReel">
      {/* story */}
      <Story
        imgSrc="https://images.unsplash.com/photo-1542328689-df6c076c1604?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2135&q=80"
        profileSrc="https://media-exp1.licdn.com/dms/image/C4D03AQH5KYC-DrkM-A/profile-displayphoto-shrink_200_200/0?e=1605744000&v=beta&t=MYFmX1BzIRnX_X2KkfovrqIJpqwnV82Ak4XMvRt1v50"
        title="Enric Trillo"
      />
      {/* story */}
      <Story
        imgSrc="https://images.unsplash.com/photo-1517926967795-31943e805dae?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2000&q=80"
        profileSrc="https://media-exp1.licdn.com/dms/image/C4D03AQH5KYC-DrkM-A/profile-displayphoto-shrink_200_200/0?e=1605744000&v=beta&t=MYFmX1BzIRnX_X2KkfovrqIJpqwnV82Ak4XMvRt1v50"
        title="Enric Trillo"
      />
      {/* story */}
      <Story
        imgSrc="https://images.unsplash.com/photo-1572225303717-a96db5e8d8b0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2134&q=80"
        profileSrc="https://media-exp1.licdn.com/dms/image/C4D03AQH5KYC-DrkM-A/profile-displayphoto-shrink_200_200/0?e=1605744000&v=beta&t=MYFmX1BzIRnX_X2KkfovrqIJpqwnV82Ak4XMvRt1v50"
        title="Enric Trillo"
      />
      {/* story */}
      <Story
        imgSrc="https://images.unsplash.com/photo-1574761828925-fe44fd0670d8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80"
        profileSrc="https://media-exp1.licdn.com/dms/image/C4D03AQH5KYC-DrkM-A/profile-displayphoto-shrink_200_200/0?e=1605744000&v=beta&t=MYFmX1BzIRnX_X2KkfovrqIJpqwnV82Ak4XMvRt1v50"
        title="Enric Trillo"
      />
      {/* story */}
      <Story
        imgSrc="https://images.unsplash.com/photo-1528702748617-c64d49f918af?ixlib=rb-1.2.1&auto=format&fit=crop&w=2134&q=80"
        profileSrc="https://media-exp1.licdn.com/dms/image/C4D03AQH5KYC-DrkM-A/profile-displayphoto-shrink_200_200/0?e=1605744000&v=beta&t=MYFmX1BzIRnX_X2KkfovrqIJpqwnV82Ak4XMvRt1v50"
        title="Enric Trillo"
      />
    </div>
  );
}

export default StoryReel;
